<div class="mnc-dmepos h-full">
  <router-outlet />
</div>
